import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        this.events = {
            click: {
                placeholder: "hide"
            }
        }

        this.$placeholder = this.$('placeholder')[0]
        this.$iframe = this.$('iframe')[0]
    }

    init() {
    }

    hide() {
        this.$placeholder.classList.add('is-hidden')

        // Ajouter autoplay à l'URL de l'iframe
        const src = this.$iframe.dataset.src;
        const autoplaySrc = src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`;
        this.$iframe.src = autoplaySrc;
    }

    destroy() {
        super.destroy()
    }

}